import axios from 'axios';

const getList = params => axios.get('/modos-pagamentos/similares', {
  params,
});

export default {
  getList,
};
